<svg
  class="gd-inline-spinner__svg"
  [attr.width]="diameter"
  [attr.height]="diameter"
  [attr.viewBox]="'0 0 ' + diameter + ' ' + diameter"
  aria-hidden="true"
  focusable="false"
>
  <circle
    class="gd-inline-spinner__track"
    [attr.cx]="center"
    [attr.cy]="center"
    [attr.r]="radius"
    [attr.stroke-width]="strokeWidth"
    fill="none"
  />
  <circle
    class="gd-inline-spinner__arc"
    [attr.cx]="center"
    [attr.cy]="center"
    [attr.r]="radius"
    [attr.stroke-width]="strokeWidth"
    [attr.stroke-dasharray]="arcDashArray"
    stroke-linecap="round"
    fill="none"
  />
</svg>
<span *ngIf="label" class="cdk-visually-hidden">{{ label }}</span>
